import { DataGridRowSkeleton } from './DataGridRowSkeleton';

export default DataGridRowSkeleton;
